import {triggerFreeTextEnter} from "@js/parts/search/functions/freeSearchForm/triggerFreeTextEnter";
import {handleFreeTextQueryTracking} from "@js/parts/search/functions/freeSearchForm/handleFreeTextQueryTracking";
import {handleMoveFreeTextSearchElement} from "@js/parts/search/functions/freeSearchForm/handleMoveFreeTextSearchElement";
import {fetchFreeTextSearchData, hideFreeSearchOutputWrapper, showFreeSearchOutputWrapper,fetchFreeSearchOutput, renderSearchLoader} from "@js/parts/search/functions/freeSearchForm/output";
import {triggerDocumentEvent} from "@js/globalFunctions/events";

let returnToSender = false;
$(document).ready(function() {

	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								INIT

	************************************************************************/

	handleFreeTextQueryTracking();
	handleMoveFreeTextSearchElement();




	/***********************************************************************
		  .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		 / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
								INPUT

	************************************************************************/

	$(document).on('focus','#freeSearchInputField',function(e){
		if( dataholder.freeTextSearchData === false && $('#freeSearchForm').length > 0 )
		{
			console.log('loading...');
			fetchFreeTextSearchData('initial');
		}
	});

	let lastSearchString = '';
	let internalLast = '';
	let currentFreeTextInterval = false;
	$("#freeSearchInputField").bind("keyup change", function (e) {
		e.preventDefault();
		if (!dataholder.freeTextProgrammaticChange) {
			dataholder.freeTextProgrammaticChange = true;
			dataholder.commandCount = dataholder.commandCount + 1;
			var localCount = dataholder.commandCount;

			setTimeout(function () {
				if (localCount === dataholder.commandCount) {
					if(lastSearchString !== internalLast)
					{
						const val = $(e.currentTarget).val();
						internalLast = val;
						if (val === '')
						{
							searchParameters.removeParameter('textQuery')
						}
						else
						{
							searchParameters.setParameter('textQuery', val)
						}

						$('input[name=textQuery]').val(val);
						triggerDocumentEvent('searchChanged');
					}
				}
			}, 200);


			if ((e.keyCode === 38 || e.keyCode === 40) && $("#freeSearchOutputWrapper li.currentElem").length === 0) {
				e.preventDefault();
				if (returnToSender !== true) {
					$("#freeSearchInputField").blur();
					if (e.keyCode === 38) {
						$(document).find("#freeSearchOutputWrapper li.last").addClass("currentElem");
					}
					else if (e.keyCode === 40) {
						$(document).find("#freeSearchOutputWrapper li.first").addClass("currentElem");
					}
				}
				else {
					returnToSender = false;
				}
			}
			else {
				if (typeof e.keyCode !== "undefined") {
					dataholder.searchedVal = $(this).val();
					if (dataholder.isLoadingFreeTextSearchData === true) {
						renderSearchLoader();
						lastSearchString = dataholder.searchedVal;
						if (currentFreeTextInterval !== false) {
							clearInterval(currentFreeTextInterval);
						}
						currentFreeTextInterval = setInterval(function () {
							if (dataholder.freeTextSearchData !== false) {
								if (lastSearchString.length > 2) {
									fetchFreeSearchOutput(lastSearchString, localCount);
								}
								else {
									$('#freeSearchForm .submitBtn').html(wpTranslatedStrings.terms.search);
									$("#freeSearchOutputWrapper").html("").removeClass("active");
								}
								clearInterval(currentFreeTextInterval);
							}
						}, 100);
					}
					else {
						setTimeout(function (searchedVal, localCount) {
							if (localCount === dataholder.commandCount && searchedVal !== lastSearchString) {
								lastSearchString = searchedVal;
								if (searchedVal.length > 2) {
									fetchFreeSearchOutput(searchedVal, localCount);
								}
								else {
									$('#freeSearchForm .submitBtn').html(wpTranslatedStrings.terms.search);
									$("#freeSearchOutputWrapper").html("").removeClass("active");
								}
							}

						}, 100, dataholder.searchedVal, localCount);
					}


				}
				else {
				}
			}
			dataholder.freeTextProgrammaticChange = false;
		}
	});

	$(document).on('submit','#freeSearchForm', function(e){
		e.preventDefault();
		if(dataholder.userMayEnter === false){
			if( dataholder.enterInterval !== false )
			{
				clearInterval(dataholder.enterInterval);
			}
			dataholder.enterInterval = setInterval(function(){
				if(dataholder.userMayEnter === true){
					clearInterval(dataholder.enterInterval);
					triggerFreeTextEnter();
				}
			}, 100);

		}else{
			triggerFreeTextEnter();
		}
	});

	$(document).on('keydown', function(e){
		if((e.keyCode === 38 || e.keyCode === 40) && $("#freeSearchOutputWrapper li.currentElem").length > 0){
			e.preventDefault();

			if( $(document).find("#freeSearchOutputWrapper li.currentElem").length > 0 ){

				var activeElem = $(document).find("#freeSearchOutputWrapper li.currentElem");

				if(e.keyCode === 38){
					if( activeElem.hasClass("first") !== true ){
						activeElem.removeClass("currentElem");
						activeElem.prev().addClass("currentElem");
					}else{
						activeElem.removeClass("currentElem");
						$("#freeSearchInputField").focus();
						returnToSender = true;
					}
				}else if(e.keyCode === 40){
					if( activeElem.hasClass("last") !== true ){
						activeElem.removeClass("currentElem");
						activeElem.next().addClass("currentElem");
					}else{
						activeElem.removeClass("currentElem");
						$(document).find("#freeSearchOutputWrapper li").first().addClass("currentElem");
					}
				}

			}else{
				if(e.keyCode === 38){
					activeElem = $(document).find("#freeSearchOutputWrapper li").first();
					activeElem.addClass("currentElem");
				}else if(e.keyCode === 40){
					activeElem = $(document).find("#freeSearchOutputWrapper li").last();
					activeElem.addClass("currentElem");
				}

			}
		}else if(e.keyCode === 13){

			if( $(document).find("#freeSearchOutputWrapper li.currentElem").length > 0 ){
				window.location.href = $(document).find("#freeSearchOutputWrapper li.currentElem a").attr("href");
			}
		}
	});

	$(document).on('click', '.showMoreSearchItems, .showMoreSearchItems a', function(e){
		e.preventDefault();
		var url = $('.showMoreSearchItems').find('a').attr('href');
		var query = $('#freeSearchInputField').val();
		window.location.href = url.replace('/?sqs','/?freeTextQuery=true&query='+query+'&label=showFullResult&sqs');
	});

	$(document).on('click','.freeTextResultShown',function(e){
		if( $(e.target).closest('#search-kat-number').length === 0 )
		{
			if( $(window).width() > 767 )
			{
				hideFreeSearchOutputWrapper();
			}
		}
	});

	$(document).on('focus','#freeSearchInputField',function(e){
		if( $('#freeSearchOutputWrapper').find('.searchHouseItem').length !== 0 )
		{
			showFreeSearchOutputWrapper();
		}
	});
});
